import React from 'react';
import './toggle.scss';
import GeckoFieldBase from '../_base.jsx';

class GeckoFieldToggle extends GeckoFieldBase {
  prepareValue() {
    return !this.value();
  }

  render() {
    return (
      <div>
        <input
          id={this.renderId()}
          type="checkbox"
          className="toggle"
          checked={this.value()}
          onChange={() => {}}
          disabled={this.isDisabled()}
        />

        <label
          className="control-label"
          onClick={this.isDisabled() ? null : this.handleChange.bind(this)}
        ></label>
      </div>
    );
  }
}

export default GeckoFieldToggle;
